<template>
  <MainLayout class="home px-1 pt-md-4 pb-0">
    <ClassModeAlert />
    <WelcomeModal />

    <v-row>
      <v-col
        md="7"
        sm="12"
      >
        <h1>{{ $t('GAMES.TITLE') }}</h1>

        <GameCard
          v-for="game in games"
          :key="game.route"
          :title="$t(game.title)"
          :description="$t(game.description)"
          :avatar="game.avatar"
          :route="game.route"
          :disabled="game.disabled"
        >
          <!-- @click="wentToGame()" -->
        </GameCard>
      </v-col>

      <v-col
        cols="5"
        sm="hidden"
        class="hidden-sm-and-down"
      >
        <GlobalRanking />
      </v-col>
    </v-row>

    <ProjectBy />
  </MainLayout>
</template>

<!-- repeated in search for search container, move to global? -->
<style scoped>
  .home {
    background: rgb(249,249,249);
    background: linear-gradient(0deg, rgba(249,249,249,1) 0%, rgba(255,255,255,1) 100%);
  }
</style>

<script>
import MainLayout from '@/layouts/MainLayout.vue';

import ClassModeAlert from '@/components/ClassModeAlert.vue';
import GameCard from '@/components/GameCard.vue';
import GlobalRanking from '@/components/ranking/GlobalRanking.vue';
import ProjectBy from '@/components/ProjectBy.vue';
import WelcomeModal from '@/components/WelcomeModal.vue';

// Thresholds for launching the post-evaluation form
// const CARDS_THRESHOLD = 10;
// const RONDO_THRESHOLD = 23;
// const QUIZ_THRESHOLD = 10;
// const ANSWERS_THRESHOLD = 15;

export default {
  name: 'Home',
  components: {
    MainLayout,
    ClassModeAlert,
    GameCard,
    GlobalRanking,
    ProjectBy,
    WelcomeModal,
  },
  computed: {
    games() {
      const games = [
        {
          title: 'GAME.RONDO.TITLE',
          description: 'GAME.RONDO.DESCRIPTION',
          avatar: '01',
          route: 'rondo',
        },
        {
          title: 'GAME.CARDS.TITLE',
          description: 'GAME.CARDS.DESCRIPTION',
          avatar: '02',
          route: 'cards',
        },
        {
          title: 'GAME.QUIZ.TITLE',
          description: 'GAME.QUIZ.DESCRIPTION',
          avatar: '03',
          route: 'quiz',
          disabled: this.isClassMode,
        },
      ];

      return games;
    },
    // stats() {
    //   return this.$store.state.stats;
    // },
  },
  // methods: {
  //   shouldPostEvaluate() {
  //     const { cards, rondo, quiz } = this.stats;

  //     // if (!this.$store.state.settings.postEvaluated
  //     //   && cards >= CARDS_THRESHOLD
  //     //   && rondo >= RONDO_THRESHOLD
  //     //   && quiz >= QUIZ_THRESHOLD
  //     // ) {
  //     if (!this.$store.state.settings.postEvaluated
  //       && (cards + rondo + quiz) >= ANSWERS_THRESHOLD
  //     ) {
  //       return true;
  //     }

  //     return false;
  //   },
  //   postEvaluate() {
  //     if (this.shouldPostEvaluate() && !this.$store.state.evaluate.wentToPost) {
  //       this.$store.dispatch('evaluate/dismissPost');
  //       this.$router.push({ name: 'form' });
  //     }
  //   },
  //   wentToGame() {
  //     if (this.shouldPostEvaluate()) {
  //       this.$store.dispatch('evaluate/resetPost');
  //     }
  //   },
  // },
  // created() {
  //   this.$store.dispatch('stats/get')
  //     .then(() => this.postEvaluate());
  // },
};
</script>
